// src/scenes/global/Topbar.jsx
import React, { useContext } from "react";
import { Box, IconButton, useTheme, Tooltip, Button } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import { Link as RouterLink } from "react-router-dom";
import { ColorModeContext, tokens } from "../../theme";

/* Icons */
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SearchIcon from "@mui/icons-material/Search";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";

const Topbar = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const colorMode = useContext(ColorModeContext);

    const pillBase = {
        borderRadius: 9999,
        textTransform: "none",
        fontWeight: 800,
        px: 1.8,
        // remove visible �container� edges
        border: "none",
        outline: "none",
        boxShadow: "none",
        "&:hover": { transform: "translateY(-1px)", boxShadow: "none" },
        "&:focus-visible": { outline: "none" },
    };

    return (
        <Box display="flex" justifyContent="space-between" p={2}>
            {/* SEARCH BAR */}
            <Box
                display="flex"
                alignItems="center"
                backgroundColor={colors.primary[400]}
                borderRadius="8px"
                sx={{
                    px: 1,
                    boxShadow:
                        theme.palette.mode === "dark"
                            ? `0 0 0 1px rgba(255,255,255,0.06)`
                            : `0 1px 3px rgba(0,0,0,0.12)`,
                }}
            >
                <InputBase sx={{ ml: 1, flex: 1, minWidth: 240 }} placeholder="Search" />
                <IconButton type="button" sx={{ p: 1.0 }}>
                    <SearchIcon />
                </IconButton>
            </Box>

            {/* RIGHT SIDE */}
            <Box display="flex" alignItems="center" gap={1.25}>
                {/* DOCUMENTS (pill, no edge) */}
                <Tooltip title="Open Document Management">
                    <Button
                        component={RouterLink}
                        to="/documentmanagement"
                        color="info"
                        variant="contained"
                        disableElevation
                        startIcon={
                            <FolderOpenIcon
                                sx={{
                                    color:
                                        theme.palette.mode === "dark"
                                            ? theme.palette.info.contrastText
                                            : theme.palette.common.white,
                                }}
                            />
                        }
                        sx={{
                            ...pillBase,
                            // soft internal gradient without outlines
                            backgroundImage:
                                theme.palette.mode === "dark"
                                    ? "linear-gradient(135deg, #38BDF8, #818CF8)"
                                    : "linear-gradient(135deg, #3B82F6, #10B981)",
                            color: theme.palette.common.white,
                        }}
                    >
                        Documents
                    </Button>
                </Tooltip>

                {/* SUPPORT (pill, no edge) */}
                <Tooltip title="Open Support">
                    <Button
                        component={RouterLink}
                        to="/support/supportpage"
                        color="secondary"
                        variant="contained"
                        disableElevation
                        startIcon={
                            <SupportAgentIcon
                                sx={{
                                    color:
                                        theme.palette.mode === "dark"
                                            ? theme.palette.secondary.contrastText
                                            : theme.palette.common.white,
                                }}
                            />
                        }
                        sx={{
                            ...pillBase,
                            backgroundImage:
                                theme.palette.mode === "dark"
                                    ? "linear-gradient(135deg, #22C55E, #06B6D4)"
                                    : "linear-gradient(135deg, #34D399, #22D3EE)",
                            color: theme.palette.common.white,
                        }}
                    >
                        Support
                    </Button>
                </Tooltip>

                {/* THEME TOGGLE */}
                <IconButton onClick={colorMode.toggleColorMode}>
                    {theme.palette.mode === "dark" ? (
                        <DarkModeOutlinedIcon />
                    ) : (
                        <LightModeOutlinedIcon />
                    )}
                </IconButton>

                {/* NOTIFICATIONS */}
                <IconButton>
                    <NotificationsOutlinedIcon />
                </IconButton>
            </Box>
        </Box>
    );
};

export default Topbar;
